<template>
  <client-only>
    <div
      v-if="amount && isSunShop"
      data-pp-message
      data-pp-style-layout="text"
      data-pp-style-logo-type="inline"
      data-pp-style-text-color="black"
      data-pp-style-text-size="12"
      :data-pp-amount="amount"
      :data-pp-placement="placement"
      data-pp-buyercountry="US"
      :style="$attrs.style"
    ></div>
  </client-only>
</template>

<script lang="ts" setup>
import { getShopCode, ShopCode } from '@/utils/shop'

defineProps<{
  amount: string | number
  placement: 'product' | 'cart' | 'payment'
}>()

const isSunShop = getShopCode() === ShopCode.SUN
</script>
